<template>
    <button v-if="type === 'button'" @click="$emit('click')" class="button" :class="classes">
      <slot></slot>
    </button>
    <a :href="link" v-else class="button" :class="classes">
      <slot></slot>
    </a>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'Button',
  props: {
    classes: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    },
    link: {
      type: String,
      default: '#'
    }
  },

  components: {},

  data() {
    return {

    }
  },

  mounted () {},

  created () {},

  updated () {},

  methods: {},

  watch: {},

  computed: {
    ...mapState({

    })
  }
}
</script>

<style lang="scss" scoped>

</style>
